import { Backdrop, Box, Button, CircularProgress, Stack, TextField, Checkbox, Typography, MenuItem } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { API } from '../../conf';
import { Context } from '../../App';
import moment from 'moment';

export default function ProjectForm({close, showResult, setProjects, project=null}) {
    const { updateConnect, region } = React.useContext(Context);
    const [comptes, setComptes] = useState([]);
    
    const [titre, setTitre] = useState(project?.titre || '');
    const [description, setDescription] = useState(project?.description || '');
    const [imageFile, setImage] = useState(project?.image || '');
    const [dateDebut, setDateDebut] = useState(project?.dateDebut? moment.utc(project.dateDebut).format('yyyy-MM-DD') : '');
    const [dateFin, setDateFin] = useState(project?.dateFin ? moment.utc(project.dateFin).format('yyyy-MM-DD') : '');
    const [type, setType] = useState(project?.type || '');
    const [montant, setMontant] = useState(project?.montant || 0);
    const [montantCollecte, setMontantCollecte] = useState(project?.montantCollecte || 0);
    const [compte, setCompte] = useState(project?.compte || '');
    const [organisateur, setOrganisateur] = useState(project?.organisateur || '');
    const [loading, setLoading] = useState(false);

    function handleSave(e) {
        e.preventDefault();
        setLoading(true);
        
        const newProject = {titre, description, dateDebut, dateFin, type, montant, montantCollecte, organisateur, compte, region,
            statut:moment.utc(dateDebut).isAfter(moment()) ? 'à venir' : moment.utc(dateFin).isBefore(moment()) ? 'terminé' : 'en cours', 
        };
        let formdata = new FormData()
        for (let key in newProject) {
            formdata.append(key, newProject[key]);
        }
        if(imageFile instanceof File) {
            formdata.append('imageFile', imageFile);
        }

        const url = API.concat(project?._id ? `/project/${project._id}` : '/project');
        
        fetch(url, {
            method: project?._id ? 'PATCH':'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            },
            body: formdata
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                updateConnect(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', token);
                }
                if (response.status === 200) {
                    const json = await response.json();
                    if (json) {
                        setProjects(prev => project ? prev.map(p => p._id === project._id ? json : p) : [...prev, json]);
                    }
                    showResult(Boolean(json));
                } else {
                    showResult(false);
                }
            }
        }).catch(error => {
            console.error("Error saving project:", error);
            showResult(false);
        }).finally(() => {
            setLoading(false);
            close(); // Close the form after saving
        });
    }

    useEffect(()=>{
        const fetchComptes = async () => {
            try {
                const response = await fetch(API.concat(`/comptes/federation/liaison?region=${region}`), {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                    }
                });
                if (response.status === 401) {
                    sessionStorage.clear();
                    updateConnect(false);
                } else if (response.ok) {
                    const data = await response.json();
                    setComptes(data);
                } else {
                    console.error("Failed to fetch comptes:", response.statusText);
                }
            } catch (error) {
                console.error("Error fetching comptes:", error);
            }
        };

        fetchComptes();
    },[])

    return (
        <Box component={'form'} onSubmit={handleSave} sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding:2, minWidth: '200px' }}>

            <Stack direction="row" gap={1} flex={1} flexWrap='wrap' alignItems="center">
                <TextField fullWidth variant='filled' label='Titre' value={titre} onChange={(e) => setTitre(e.target.value)} required sx={{minWidth:'200px'}} />
                <TextField fullWidth label='Organisateur' value={organisateur} onChange={(e) => setOrganisateur(e.target.value)} required sx={{minWidth:'200px'}} />
            </Stack>
            <TextField fullWidth multiline rows={3} label='Description' value={description} onChange={(e) => setDescription(e.target.value)} required sx={{minWidth:'200px'}} />

            <Stack direction="row" gap={1} alignItems="center">
                <TextField fullWidth type='date' label='Début' InputLabelProps={{shrink: true}} value={dateDebut} onChange={(e) => setDateDebut(e.target.value)} required sx={{minWidth:'100px'}} />
                <TextField fullWidth type='date' label='Fin' InputLabelProps={{shrink: true}} value={dateFin} onChange={(e) => setDateFin(e.target.value)} required sx={{minWidth:'100px'}} />
            </Stack>

            <Stack direction="row" gap={1} alignItems="center">
                <TextField select label='type' value={type} onChange={(e) => setType(e.target.value)} fullWidth required sx={{minWidth:'200px'}}>
                    <MenuItem value='évènement'>Évènement</MenuItem>
                    <MenuItem value='collecte'>Collecte de financement</MenuItem>
                </TextField>
                <TextField fullWidth type='number' label='Montant' value={montant} onFocus={()=>{if(!montant||montant===0) setMontant('')}} onChange={(e) => setMontant(e.target.value)} required sx={{minWidth:'100px'}} />
            </Stack>

            <Stack direction='row' gap={2} alignItems='center'>
                <Typography variant='body1' noWrap sx={{flexShrink:0, fontWeight:'bold'}}>Destination des fonds</Typography>
                <TextField select fullWidth label='Compte' value={compte} onChange={(e) => setCompte(e.target.value)} sx={{minWidth:'200px'}}>
                    {comptes.map((c) => (
                        <MenuItem key={c._id} value={c.num}>{c.libelle}</MenuItem>
                    ))}
                    <MenuItem value=''>Aucun</MenuItem>
                </TextField>
            </Stack>
            
            <Button
                variant="outlined"
                component="label"
                sx={{ alignSelf: 'flex-start', mb: 1 }}
            >
                Importer une image d'affiche
                <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={async (e) => {
                        const file = e.target.files[0];
                        if (!file) return;
                        if (file.size > 5 * 1024 * 1024) {
                            alert('Le fichier est trop volumineux. Veuillez choisir un fichier de moins de 5 Mo.');
                            return;
                        }
                        setImage(file);
                    }}
                />
            </Button>
            { imageFile!=='' && <img src={project? (API+imageFile) : URL.createObjectURL(imageFile)} width={'300px'}  />}

            <Stack direction="row" spacing={2} alignItems="center" justifyContent={'flex-end'}>
                <Button variant="outlined" onClick={close}>annuler</Button>
                <Button variant="contained" color="primary" type="submit" disabled={loading}>
                    {loading && <CircularProgress size={24} />} Enregistrer
                </Button>
            </Stack>

            <Backdrop open={loading}><CircularProgress/></Backdrop>
        </Box>
    );
}